module.exports = __webpack_public_path__ + "img/f8.dd634e5c.jpg";